let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("73K9B")).then(() => parcelRequire('kLLtw'));